import type { PropsWithChildren, ReactNode } from 'react';

export interface FormFieldProps {
  label: ReactNode;
  /** 显示红色星号 */
  required?: boolean;
  /** 校验错误（红色 11px，显示在字段下方） */
  error?: string | null;
  /** 辅助提示（有错误时让位给错误文案） */
  hint?: ReactNode;
  htmlFor?: string;
  className?: string;
}

/**
 * 表单字段容器：标签 + 控件 + 错误 / 提示。
 *
 * <FormField label="项目名称" required error={err}>
 *   <input className="pm-input" … />
 * </FormField>
 */
export default function FormField({
  label,
  required,
  error,
  hint,
  htmlFor,
  className,
  children,
}: PropsWithChildren<FormFieldProps>) {
  return (
    <div className={['pm-field', error ? 'is-error' : '', className].filter(Boolean).join(' ')}>
      <label className="pm-field__label" htmlFor={htmlFor}>
        {label}
        {required && <em className="pm-field__req">*</em>}
      </label>
      {children}
      {hint && !error && <div className="pm-field__hint">{hint}</div>}
      {error && <div className="pm-field__err">{error}</div>}
    </div>
  );
}
